var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.homeTabsRendered ? [_c("app-home-tabs")] : _vm._e(),
      _c("v-divider"),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              staticStyle: { padding: "0px" },
              attrs: { id: "vicDiv", md4: "", sm4: "", xs12: "" }
            },
            [[[_c("vehiculos-grid")]]],
            2
          ),
          _c("v-flex", [[_c("mapa")]], 2)
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }